// extracted by mini-css-extract-plugin
export default {"pageTitle":"schedule_pageTitle__L5oyx","schedule":"schedule_schedule__CmA3+","box":"schedule_box__DDEWx","empty":"schedule_empty__7hwzN"};